import { env } from '../env';
import { navegarEAguardarSaida } from '../location';

/**
 * Enquanto os dois sites convivem, parte das páginas ainda mora no site antigo. Estas
 * funções são a forma de mandar o usuário para lá, e ficam junto do `enabledPageGuard`,
 * que é quem decide se a página já existe no site novo.
 *
 * A convivência entre os dois sites está em `docs/migracao.md`.
 */
export function createOldSiteRedirectUrl(page: string) {
  const normalizedPage = page.startsWith('/') ? page.slice(1) : page;

  return `${env.VITE_OLD_SITE_REDIRECT_URL}${normalizedPage}`;
}

export function redirectToOldSite(page: string, { replace = false } = {}) {
  return navegarEAguardarSaida(createOldSiteRedirectUrl(page), { replace });
}
